<template>
  <div>
    <div class="accordions is-hidden-tablet">
      <div class="accordion">
        <div class="accordion-header toggle">
          <p class="is-size-4" v-t="`NetworkColumn.${title}`"></p>
        </div>
        <div class="accordion-body">
          <div class="accordion-content">
            <ul class="menu-list has-text-weight-bold">
              <li v-for="(link,index) in links" :key="index">
                <a
                  v-html="$t(`NetworkColumn.${link.name}`)"
                  :href="link.url"
                  target="_blank"
                  @click.stop
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="column has-text-left is-hidden-mobile" :style="columnClass">
      <h1
        class="title is-7 is-marginless is-uppercase has-text-info menu-label"
        style="padding-left:8px"
        v-t="`NetworkColumn.${title}`"
      ></h1>
      <ul class="menu-list has-text-weight-bold" :class="{'menu-list-footer':inFooter}">
        <li v-for="(link,index) in links" :key="index">
          <a v-html="$t(`NetworkColumn.${link.name}`)" :href="link.url"></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Accordion from 'bulma-accordion'
export default {
  components: {},
  mounted () {
    Accordion.attach()
  },
  props: {
    title: { type: String, default: null },
    links: {
      type: Array,
      default () {
        return []
      }
    },
    borderColor: { type: String, default: '#498EDF' },
    inFooter: { type: Boolean, default: false }
  },
  data () {
    return {
      active: false
    }
  },
  computed: {
    columnClass: function () {
      return {
        'border-left': `1px solid ${this.borderColor}`
      }
    },
    hoverClass: function () {
      return {
        'background-color': this.hoverColor
      }
    }
  }
}
</script>

<style scoped lang="scss">
li {
  margin: 15px auto;
}
.column {
  padding-left: 0.125rem !important;
  padding-right: 0.125rem !important;
}
.menu-list-footer {
  a:hover {
    background-color: #f2f2f2;
    color: unset;
  }
}
</style>
<style scoped lang="sass">
$text: white
$accordion-header-background-color: transparent !default
$accordion-header-color: #498EDF !default
$accordion-background-color: transparent !default
$accordion-content-pre-background-color: transparent !default
$accordion-content-pre-code-background-color: transparent !default
$accordion-content-border: unset
@import '~bulma/sass/utilities/_all';
@import "bulma-accordion/dist/css/bulma-accordion.sass"
.accordion-header
  margin: auto
</style>
